"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STATIC_MODE_ID = exports.POST_ONBOARDING_TASK_ID = exports.POST_ONBOARDING_TASK_IDS = exports.PUBLIC_METADATA_CONSTS = exports.ONBOARDING_CONSTS = void 0;
exports.isPostOnboardingTaskId = isPostOnboardingTaskId;
exports.ONBOARDING_CONSTS = {
    OrganizationDefaultName: 'Your Workspace',
    BrandDefaultName: 'Your first brand',
    ProductDefaultName: 'Your first product',
    LanguageUuidMetadataKey: 'languageUuid',
};
exports.PUBLIC_METADATA_CONSTS = {
    WebhookCompleted: 'webhookCompleted',
};
/**
 * Stable product identities for tasks offered by the post-onboarding flow. These ids cross the
 * web/API boundary and are persisted on the launched Agent; copy, ordering, and routing modes are
 * deliberately not part of the identity contract.
 */
exports.POST_ONBOARDING_TASK_IDS = [
    'static-ad-concepts',
    'research-competitors',
    'ugc-video',
    'account-analytics',
    'ecom-assets',
    'build-brand-intelligence',
];
/** Named accessors keep call sites semantic while the tuple above remains the single literal source. */
exports.POST_ONBOARDING_TASK_ID = {
    StaticAdConcepts: exports.POST_ONBOARDING_TASK_IDS[0],
    ResearchCompetitors: exports.POST_ONBOARDING_TASK_IDS[1],
    UgcVideo: exports.POST_ONBOARDING_TASK_IDS[2],
    AccountAnalytics: exports.POST_ONBOARDING_TASK_IDS[3],
    EcomAssets: exports.POST_ONBOARDING_TASK_IDS[4],
    BuildBrandIntelligence: exports.POST_ONBOARDING_TASK_IDS[5],
};
function isPostOnboardingTaskId(value) {
    return typeof value === 'string' && exports.POST_ONBOARDING_TASK_IDS.includes(value);
}
/**
 * The graphic designer's static-ad chat mode id. Crosses the web/API boundary: the post-onboarding
 * launch pre-switches the onboarding chat to this mode server-side (`PostOnboardingLaunchService`),
 * and the client mirrors the switch into its agent-detail cache for first-frame attribution.
 */
exports.STATIC_MODE_ID = 'static';
